import { type BaseObject } from "../../../evidence/base";
import { cn } from "../../../utils/cn";
import { Table } from "../../atoms/table";
import { useDataTableContext } from "../context";
import { type DataTableProps } from "../types";
import { DataTableBody } from "./body/data-table-body";
import { DataTableHeader } from "./data-table-header";

export function DataTableTable<TData extends BaseObject>({
  contextMenuActions,
}: Pick<DataTableProps<TData>, "contextMenuActions">) {
  const { dataQuery, url } = useDataTableContext();

  return (
    <Table wrapperClassName={cn(dataQuery.isLoading && "overflow-hidden")}>
      <DataTableHeader contextMenuActions={contextMenuActions} />
      <DataTableBody
        isLoading={dataQuery.isLoading}
        url={url}
        contextMenuActions={contextMenuActions}
      />
    </Table>
  );
}
